import { render, staticRenderFns } from "./EventRecord.vue?vue&type=template&id=82971346&scoped=true"
import script from "./EventRecord.vue?vue&type=script&lang=js"
export * from "./EventRecord.vue?vue&type=script&lang=js"
import style0 from "./EventRecord.vue?vue&type=style&index=0&id=82971346&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82971346",
  null
  
)

export default component.exports